import { useApi } from "./useApi";

import { usePool } from "./usePool";

export const useFixtures = () => {
  const { client } = useApi();
  const { getMainPool } = usePool();

  const updateFixtureStatus = async (poolId, matchId, status) => {
    await client.patch(`/v1/fixtures/status`, {
      poolId,
      matchId,
      status,
    });
    await getMainPool();
  };

  return {
    updateFixtureStatus,
  };
};
